module.exports = __webpack_public_path__ + "images/analytics_report.webp";